export const editorLanguage: { [key: string]: string } = {
  azcli: "azcli",
  bat: "bat",
  bicep: "bicep",
  clj: "clojure",
  cljs: "clojure",
  cljc: "clojure",
  c: "c",
  i: "c",
  mi: "c",
  cc: "cpp",
  cpp: "cpp",
  cxx: "cpp",
  "c++": "cpp",
  cp: "cpp",
  mii: "cpp",
  ii: "cpp",
  cs: "csharp",
  csx: "csharp",
  css: "css",
  dart: "dart",
  dockerfile: "dockerfile",
  ex: "elixir",
  exs: "elixir",
  eex: "elixir",
  leex: "elixir",
  heex: "elixir",
  fs: "fsharp",
  fsx: "fsharp",
  fsi: "fsharp",
  fsproj: "fsharp",
  go: "go",
  graphql: "graphql",
  gql: "graphql",
  hbs: "handlebars",
  mustache: "handlebars",
  hcl: "hcl",
  htm: "html",
  xhtml: "html",
  html_vm: "html",
  asp: "html",
  ini: "ini",
  java: "java",
  jsp: "java",
  esx: "javascript",
  mjs: "javascript",
  js: "javascript",
  jsx: "javascript",
  jl: "julia",
  kt: "kotlin",
  kts: "kotlin",
  less: "less",
  lua: "lua",
  liquid: "liquid",
  md: "markdown",
  markdown: "markdown",
  rst: "markdown",
  m: "objective-c",
  pas: "pascal",
  pm: "perl",
  raku: "perl",
  pgsql: "pgsql",
  ps1: "powershell",
  psm1: "powershell",
  psd1: "powershell",
  ps1xml: "powershell",
  psc1: "powershell",
  pssc: "powershell",
  proto: "proto",
  jade: "pug",
  pug: "pug",
  py: "python",
  qs: "qsharp",
  r: "r",
  rmd: "r",
  cshtml: "razor",
  vbhtml: "razor",
  rb: "ruby",
  erb: "ruby",
  rs: "rust",
  ron: "rust",
  scala: "scala",
  sc: "scala",
  ss: "scheme",
  scm: "scheme",
  scss: "scss",
  sol: "sol",
  sql: "sql",
  swift: "swift",
  vhd: "verilog",
  sv: "verilog",
  svh: "verilog",
  tcl: "tcl",
  twig: "twig",
  tsx: "javascript",
  ts: "typescript",
  vb: "vb",
  xml: "xml",
  plist: "xml",
  xsd: "xml",
  dtd: "xml",
  xsl: "xml",
  xslt: "xml",
  resx: "xml",
  iml: "xml",
  xquery: "xml",
  tmLanguage: "xml",
  manifest: "xml",
  project: "xml",
  dmn: "xml",
  jrxml: "xml",
  yml: "yaml",
  yaml: "yaml",
  "YAML-tmLanguage": "yaml",
  json: "json",
  jsonc: "json",
  tsbuildinfo: "json",
  json5: "json",
  jsonl: "json",
  ndjson: "json",
  plaintext: "plaintext",
  abap: "abap",
  apex: "apex",
  cameligo: "cameligo",
  clojure: "clojure",
  coffeescript: "coffeescript",
  csharp: "csharp",
  csp: "csp",
  cypher: "cypher",
  ecl: "ecl",
  elixir: "elixir",
  flow9: "flow9",
  fsharp: "fsharp",
  freemarker2: "freemarker2",
  handlebars: "handlebars",
  html: "html",
  javascript: "javascript",
  julia: "julia",
  kotlin: "kotlin",
  lexon: "lexon",
  m3: "m3",
  mips: "mips",
  msdax: "msdax",
  mysql: "mysql",
  "objective-c": "objective-c",
  pascal: "pascal",
  pascaligo: "pascaligo",
  perl: "perl",
  php: "php",
  pla: "pla",
  postiats: "postiats",
  powerquery: "powerquery",
  powershell: "powershell",
  python: "python",
  qsharp: "qsharp",
  razor: "razor",
  redis: "redis",
  redshift: "redshift",
  restructuredtext: "restructuredtext",
  ruby: "ruby",
  rust: "rust",
  sb: "sb",
  scheme: "scheme",
  shell: "shell",
  aes: "aes",
  sparql: "sparql",
  st: "st",
  systemverilog: "systemverilog",
  verilog: "verilog",
  typescript: "typescript",
};

export const supportedFileTypes: { [key: string]: string } = {
  abap: "abap",
  aes: "aes",
  apex: "apex",
  asp: "asp",
  azcli: "azcli",
  bat: "bat",
  bicep: "bicep",
  c: "c",
  "c++": "c++",
  cameligo: "cameligo",
  cc: "cc",
  clj: "clj",
  cljc: "cljc",
  cljs: "cljs",
  clojure: "clojure",
  coffeescript: "coffeescript",
  cp: "cp",
  cpp: "cpp",
  cs: "cs",
  csharp: "csharp",
  cshtml: "cshtml",
  csp: "csp",
  css: "css",
  csx: "csx",
  cxx: "cxx",
  cypher: "cypher",
  dart: "dart",
  dmn: "dmn",
  dockerfile: "dockerfile",
  dtd: "dtd",
  ecl: "ecl",
  eex: "eex",
  elixir: "elixir",
  erb: "erb",
  esx: "esx",
  ex: "ex",
  exs: "exs",
  flow9: "flow9",
  freemarker2: "freemarker2",
  fs: "fs",
  fsharp: "fsharp",
  fsi: "fsi",
  fsproj: "fsproj",
  fsx: "fsx",
  go: "go",
  gql: "gql",
  graphql: "graphql",
  handlebars: "handlebars",
  hbs: "hbs",
  hcl: "hcl",
  heex: "heex",
  htm: "htm",
  html: "html",
  html_vm: "html_vm",
  i: "i",
  ii: "ii",
  iml: "iml",
  ini: "ini",
  jade: "jade",
  java: "java",
  javascript: "javascript",
  jl: "jl",
  jrxml: "jrxml",
  js: "js",
  json: "json",
  json5: "json5",
  jsonc: "jsonc",
  jsonl: "jsonl",
  jsp: "jsp",
  jsx: "jsx",
  julia: "julia",
  kotlin: "kotlin",
  kt: "kt",
  kts: "kts",
  leex: "leex",
  less: "less",
  lexon: "lexon",
  liquid: "liquid",
  lua: "lua",
  m: "m",
  m3: "m3",
  manifest: "manifest",
  markdown: "markdown",
  md: "md",
  mi: "mi",
  mii: "mii",
  mips: "mips",
  mjs: "mjs",
  msdax: "msdax",
  mustache: "mustache",
  mysql: "mysql",
  ndjson: "ndjson",
  "objective-c": "objective-c",
  pas: "pas",
  pascal: "pascal",
  pascaligo: "pascaligo",
  perl: "perl",
  pgsql: "pgsql",
  php: "php",
  pla: "pla",
  plaintext: "plaintext",
  plist: "plist",
  pm: "pm",
  postiats: "postiats",
  powerquery: "powerquery",
  powershell: "powershell",
  project: "project",
  proto: "proto",
  ps1: "ps1",
  ps1xml: "ps1xml",
  psc1: "psc1",
  psd1: "psd1",
  psm1: "psm1",
  pssc: "pssc",
  pug: "pug",
  py: "py",
  python: "python",
  qs: "qs",
  qsharp: "qsharp",
  r: "r",
  raku: "raku",
  razor: "razor",
  rb: "rb",
  redis: "redis",
  redshift: "redshift",
  restructuredtext: "restructuredtext",
  resx: "resx",
  rmd: "rmd",
  ron: "ron",
  rs: "rs",
  rst: "rst",
  ruby: "ruby",
  rust: "rust",
  sb: "sb",
  sc: "sc",
  scala: "scala",
  scheme: "scheme",
  scm: "scm",
  scss: "scss",
  shell: "shell",
  sol: "sol",
  sparql: "sparql",
  sql: "sql",
  ss: "ss",
  st: "st",
  sv: "sv",
  svh: "svh",
  swift: "swift",
  systemverilog: "systemverilog",
  tcl: "tcl",
  tmLanguage: "tmLanguage",
  ts: "ts",
  tsbuildinfo: "tsbuildinfo",
  tsx: "tsx",
  twig: "twig",
  typescript: "typescript",
  txt: "txt",
  vb: "vb",
  vbhtml: "vbhtml",
  verilog: "verilog",
  vhd: "vhd",
  xhtml: "xhtml",
  xml: "xml",
  xquery: "xquery",
  xsd: "xsd",
  xsl: "xsl",
  xslt: "xslt",
  yaml: "yaml",
  yml: "yml",
  "YAML-tmLanguage": "yaml",
};

export const SUPPORTED_LANGUAGES = ["cpp", "java", "python", "c", "javascript"];

export const SUPPORTED_LANGUAGES_FOR_LIVE_SERVER = ["html"];
